<template>
    <div>
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <div class="modal-header">
                            <h3><i class="icofont-youtube-play"></i> AJUDA</h3>
                        </div>
                        <div class="modal-body">
                            <slot name="body">
                                <iframe width="100%" height="315" v-bind:src="linkvideo" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </slot>
                        </div>
                        <div class="modal-footer">
                            <slot name="footer">

                                <!-- desabilitar modal para não aparecer mais -->
                                <b-form-checkbox
                                  v-model="status"
                                  @change="naoExibirAjuda()"
                                >
                                    Não exibir ajuda
                                </b-form-checkbox>
                                                                    
                                <!-- fechar modal -->
                                <button class="btn modal-default-button" @click="$emit('close-modal-ajuda')">
                                    Fechar
                                </button>
                            </slot>
                        </div>
                    </div>
                </div>
            </div>
      </transition>
    </div>
</template>

<script>
export default {
    name: 'ModalAjuda',
    props:{
        card_title:{
            type: String,
            default: ''
        },
        linkvideo: {
            type: String,
            default: ''
        },
    },
    mounted(){
        this.alterarStatusCheckbox();
    },
    data() {
        return {
            status: false
        }
    },
    methods:{

        alterarStatusCheckbox(){
            let statusModalStore = this.$store.getters.getModalAjuda(this.$props.card_title);
            if (statusModalStore.active == false) {
                this.status = true
            }else{
                this.status = false
            }
        },

        naoExibirAjuda(){
            if (this.status == false) {
                this.$store.commit('setInactiveModalAjuda', this.$props.card_title);
            }else{
                this.$store.commit('setActiveModalAjuda', this.$props.card_title);
            }
        }
    }
}
</script>

<style lang="css">
    .modal-footer{
        display: flex;
        align-items: center;
        justify-content: space-between !important;
    }
</style>